import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Admin_Parivartan_Create_Category } from "../../../../constants";
import toast from "react-hot-toast";
import axios from "axios";

const AddCategoryModal = ({ open, onClose, onRefresh }) => {
  // Modal logic and form submission would go here
  const [form, setForm] = useState({ CategoryName: "" });

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      categoryName: form.CategoryName,
    };

    try {
      const res = await axios.post(Admin_Parivartan_Create_Category, payload);
      console.log("Response:", res);
      if (res.data.success) {
        toast.success("Category Created Successfully.");
        onClose();
        handleReset();
        onRefresh();
      } else {
        toast.error(res.data.message || "Failed to create category");
      }
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || "Something went wrong";
      toast.error(message);
    }
  };

  const handleReset = () => {
    setForm({ CategoryName: "" });
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Add New Category
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <FormControl fullWidth>
              <TextField
                label="Category Name"
                value={form.CategoryName}
                onChange={(e) => handleChange("CategoryName", e.target.value)}
                variant="outlined"
                size="small"
              />
            </FormControl>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              onClose();
              handleReset();
            }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddCategoryModal;
